module.exports = __webpack_public_path__ + "img/9.a3525287.png";